// Email verified screen translations for all 11 supported languages

export const emailVerifiedTranslations = {
  pt: {
    title: "Email confirmado",
    subtitle: "A tua conta está ativa",
    description: "Já podes começar a configurar o MoneyLights.",
    action: "Começar",
    help_text: "Precisas de ajuda?",
    contact_support: "Contactar suporte",
  },
  en: {
    title: "Email verified",
    subtitle: "Your account is now active",
    description: "You can start setting up MoneyLights.",
    action: "Get started",
    help_text: "Need help?",
    contact_support: "Contact support",
  },
  es: {
    title: "Correo verificado",
    subtitle: "Tu cuenta ya está activa",
    description: "Ya puedes empezar a configurar MoneyLights.",
    action: "Empezar",
    help_text: "¿Necesitas ayuda?",
    contact_support: "Contactar soporte",
  },
  fr: {
    title: "Email vérifié",
    subtitle: "Votre compte est maintenant actif",
    description: "Vous pouvez commencer à configurer MoneyLights.",
    action: "Commencer",
    help_text: "Besoin d'aide ?",
    contact_support: "Contacter le support",
  },
  de: {
    title: "E-Mail bestätigt",
    subtitle: "Ihr Konto ist jetzt aktiv",
    description: "Sie können jetzt mit der Einrichtung von MoneyLights beginnen.",
    action: "Loslegen",
    help_text: "Brauchen Sie Hilfe?",
    contact_support: "Support kontaktieren",
  },
  it: {
    title: "Email verificata",
    subtitle: "Il tuo account è ora attivo",
    description: "Ora puoi iniziare a configurare MoneyLights.",
    action: "Inizia",
    help_text: "Hai bisogno di aiuto?",
    contact_support: "Contatta il supporto",
  },
  nl: {
    title: "E-mail bevestigd",
    subtitle: "Je account is nu actief",
    description: "Je kunt nu beginnen met het instellen van MoneyLights.",
    action: "Beginnen",
    help_text: "Hulp nodig?",
    contact_support: "Contact opnemen met support",
  },
  da: {
    title: "E-mail bekræftet",
    subtitle: "Din konto er nu aktiv",
    description: "Du kan nu begynde at konfigurere MoneyLights.",
    action: "Kom i gang",
    help_text: "Brug for hjælp?",
    contact_support: "Kontakt support",
  },
  sv: {
    title: "E-post verifierad",
    subtitle: "Ditt konto är nu aktivt",
    description: "Du kan nu börja konfigurera MoneyLights.",
    action: "Kom igång",
    help_text: "Behöver du hjälp?",
    contact_support: "Kontakta support",
  },
  fi: {
    title: "Sähköposti vahvistettu",
    subtitle: "Tilisi on nyt aktiivinen",
    description: "Voit nyt aloittaa MoneyLightsin käyttöönoton.",
    action: "Aloita",
    help_text: "Tarvitsetko apua?",
    contact_support: "Ota yhteyttä tukeen",
  },
  et: {
    title: "E-post kinnitatud",
    subtitle: "Sinu konto on nüüd aktiivne",
    description: "Saad nüüd alustada MoneyLightsi seadistamist.",
    action: "Alusta",
    help_text: "Vajad abi?",
    contact_support: "Võta ühendust toega",
  },
};
